var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFiat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M11 2.9085V4.7585C11 5.8835 10.55 6.3335 9.425 6.3335H8.075C6.95 6.3335 6.5 5.8835 6.5 4.7585V2.9085C6.5 1.7835 6.95 1.3335 8.075 1.3335H9.425C10.55 1.3335 11 1.7835 11 2.9085Z",
    fill: "#92ABFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M5.5 7.9085V9.7585C5.5 10.8835 5.05 11.3335 3.925 11.3335H2.575C1.45 11.3335 1 10.8835 1 9.7585V7.9085C1 6.7835 1.45 6.3335 2.575 6.3335H3.925C5.05 6.3335 5.5 6.7835 5.5 7.9085Z",
    fill: "#92ABFE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.38877 11.3333C7.25377 11.3333 7.12877 11.2583 7.06377 11.1433C6.99877 11.0233 6.99877 10.8833 7.06877 10.7633L7.55377 9.95326C7.65877 9.77326 7.88877 9.71826 8.06877 9.82326C8.24877 9.92826 8.30377 10.1583 8.19877 10.3383L8.10877 10.4883C9.34377 10.1683 10.2538 9.04826 10.2538 7.71826C10.2538 7.51326 10.4238 7.34326 10.6288 7.34326C10.8338 7.34326 10.9988 7.51326 10.9988 7.72326C10.9988 9.71326 9.37877 11.3333 7.38877 11.3333Z",
    fill: "#92ABFE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.375 5.3185C1.17 5.3185 1 5.1535 1 4.9435C1 2.9535 2.62 1.3335 4.61 1.3335C4.75 1.3335 4.87 1.4085 4.94 1.5235C5.005 1.6435 5.005 1.7835 4.935 1.9035L4.45 2.7085C4.34 2.8885 4.11 2.9485 3.935 2.8385C3.755 2.7335 3.7 2.5035 3.805 2.3235L3.895 2.1735C2.665 2.4935 1.75 3.6135 1.75 4.9435C1.75 5.1535 1.58 5.3185 1.375 5.3185Z",
    fill: "#92ABFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiat);
export default __webpack_public_path__ + "static/media/fiat.77ea0e6dd68fd7d6ecb4543e367e37a2.svg";
export { ForwardRef as ReactComponent };